import { useTranslation } from 'react-i18next';
import { useFilters } from './useFilters';
import {
  getGroupOfReportsRequest,
  getReportsRequest,
  IReportFilters,
  getReportDetailsRequest,
} from '../services/reports';
import { THEME as theme } from '../styles/theme';

export const RepresentativenessModes = {
  ACCEPTABLE: 'acceptable',
  GOOD: 'good',
  POOR: 'poor',
};

export const useReports = () => {
  const { currentFilters } = useFilters();
  const { t } = useTranslation();

  const downloadReportGroupList = async (signal: AbortSignal) => {
    const { reports, ...basicFilters } = currentFilters;
    if (!basicFilters.perPage) {
      return await getGroupOfReportsRequest({ ...basicFilters, perPage: '7' }, signal);
    }

    return await getGroupOfReportsRequest(basicFilters, signal);
  };

  const downloadReport = async (
    surveyId: string,
    filters: IReportFilters,
    downloadWithSearch: boolean
  ) => {
    const searchParam: any =
      downloadWithSearch && currentFilters?.search ? currentFilters?.search : '';
    if (!filters.perPage) {
      return await getReportsRequest({ ...filters, perPage: '5' }, surveyId, searchParam);
    }
    return await getReportsRequest(filters, surveyId, searchParam);
  };

  const getReportDetails = async (id: string) => await getReportDetailsRequest(id);

  const chooseRepresentativenessMode = (mode: string = RepresentativenessModes.ACCEPTABLE) => {
    switch (mode) {
      case RepresentativenessModes.ACCEPTABLE:
        return {
          borderColor: theme.colors.support.blue[100],
          background: theme.colors.support.blue[10],
        };
      case RepresentativenessModes.GOOD:
        return {
          borderColor: theme.colors.support.green[100],
          background: theme.colors.support.green[10],
        };
      case RepresentativenessModes.POOR:
        return {
          borderColor: theme.colors.support.red[100],
          background: theme.colors.support.orange[10],
        };
      default:
        return {
          borderColor: theme.colors.support.blue[100],
          background: theme.colors.support.blue[10],
        };
    }
  };

  const getReportType = (reportType: string) => {
    switch (reportType) {
      case 'team':
        return t('reports.reportType.team');
      case 'executive':
        return t('reports.reportType.executive');
    }
  };

  return {
    downloadReportGroupList,
    downloadReport,
    getReportDetails,
    chooseRepresentativenessMode,
    getReportType,
  };
};
